theme.Contact = (function() {
  function Contact(container) {     
    var sectionId = container.getAttribute('data-section-id');
    var hny = document.getElementById('honeypot');
    hny.innerHTML = '<input class="btn standard-width bottompad" type="submit" value="' + theme.language.contact_form_send + '" id="contactFormSubmit" />';
    document.getElementById('contactFormSubmit').onclick = function(ev){
      if (document.getElementById('contactFormNumber').value.length > 0) {
        ev.preventDefault();
      }
    }
  }
  return Contact;
})();